/**
 * Loading fallback component for lazy-loaded routes
 */

import { Loader2 } from "lucide-react";

export function RouteLoadingFallback() {
  return (
    <div className="flex items-center justify-center min-h-[400px]">
      <Loader2 className="w-8 h-8 animate-spin text-muted-foreground" data-testid="route-loading" />
    </div>
  );
}

